export default "__VITE_ASSET__DI$zhcOe__"